var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" py-8 border-b border-gray-700 w-full flex items-center justify-center cursor-text font-sans",attrs:{"id":_vm.domID}},[_c('div',{staticClass:"p-12 text-black text-white"},[_vm._v("\n    "+_vm._s(_vm.li.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }